<template>
  <div> 
      <div class="row">
          <div class="col-md-12" style="margin-top: -40px;">
              <graficopie  	  :titulo="''"
                              :subtitulo="''"
                              :rotulo="'DETALHES:'"
                              :legendas="legendasfinanceiro"
                              :dados="dadosfinanceiro"
                              :visualizarlegenda="false"
                              :posicaolabel="'outside'"
              ></graficopie>
          </div>
          <div class="col-md-12">
              <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px;">
                  <li v-for="(item, indice) in dadosfinanceiro" :key="indice" class="li-item-card-dash" style="height: 15px;">
                      <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                      <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.media)) }}%)
                      </span>
                  </li>
              </ul>                                            
          </div>
      </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoPie from '../../components/cmpgraficopie.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "demvendedores",

  components:{
    'graficopie'       : GraficoPie,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        legendasfinanceiro : [],
       
        showpopover             : false,
        isloading               : false,  
        totalfin                : 0,
        usuariologado           : this.$store.state.usuario,

        dadosfinanceiro        : []
        

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        hidepopover(){
          setTimeout(() => {
                    this.showpopover = false;
                }, 200); 
          
        },
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdmediafaturados(){
            let mediafat = 0;

            if(this.lstresumopedidos){
                mediafat = this.lstresumopedidos.totalfaturado / this.lstresumopedidos.qf;
            }
            return mediafat;
        }, 
        mtdmargemlucrogeral() {
          var vself               = this;
      
          const ptotalaberto		  = vself.lstresumopedidos.totalaberto;
          const ptotalfaturado	  = vself.lstresumopedidos.totalfaturado;
          const ptotalcusto 		  = vself.lstresumopedidos.totalcusto;
                
          let totalgeral          = ptotalaberto + ptotalfaturado;

          let dif                 = (parseFloat(totalgeral) - parseFloat(ptotalcusto))

          vself.margemlucrogeral  = 0;
          vself.margemlucrogeral  = dif / totalgeral * 100;
          
        },
       mtdresultadofaturamento(){
          var vself           = this;
        
          vself.$emit('handlerLoader', true);
          let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
      
 
          let parametros      = [
              {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
              {parametro: 'op',           valor : 'dash'},
              {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
              {parametro: 'periodo',      valor : periodo},
              {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
              {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
              {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
              {parametro: 'filtrotarefas',valor : ''},//' and t.sttarefa=0'},
              {parametro: 'patharquivos', valor : ''},
          ];
          let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
          retorno.then(function (response) {
              vself.totalfin = parseFloat(response.data.areceber) + parseFloat(response.data.recebido) + parseFloat(response.data.apagar) + parseFloat(response.data.pago);
              vself.dadosfinanceiro = [
                  {value: parseFloat(response.data.areceber), name: 'À RECEBER',  media : parseFloat(response.data.areceber) > 0 ? parseFloat(response.data.areceber) / vself.totalfin * 100 : 0},
                  {value: parseFloat(response.data.recebido), name: 'RECEBIDOS',  media : parseFloat(response.data.recebido) > 0 ? parseFloat(response.data.recebido) / vself.totalfin * 100 : 0},                        
                  {value: parseFloat(response.data.apagar),   name: 'À PAGAR',    media : parseFloat(response.data.apagar) > 0 ? parseFloat(response.data.apagar) / vself.totalfin * 100 : 0},
                  {value: parseFloat(response.data.pago),     name: 'PAGOS',      media : parseFloat(response.data.pago) > 0 ? parseFloat(response.data.pago) / vself.totalfin * 100 : 0}                   
              ];  

              vself.legendasfinanceiro = util.gerardadoslegendagrafico(vself.dadosfinanceiro);

              vself.$emit('handlerLoader', false);										
          }).catch(function (response) {
              vself.dadosvendedores = [];
              //loader.hide();
              vself.$emit('handlerLoader', false);	
          });                
      },
  },
  mounted(){


    setTimeout(() => {
         this.mtdresultadofaturamento();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
